import { render, staticRenderFns } from "./pick-list.vue?vue&type=template&id=0353616e&"
import script from "./pick-list.vue?vue&type=script&lang=ts&"
export * from "./pick-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports